import React from 'react'; 
import { Button, Icon } from 'semantic-ui-react';
import { SearchBar } from 'dyl-components';
import { USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';
import '../index.scss';

const Toolbar = ({ search, onSearchSubmit, cancelFunction, onChangeSearch, onOpenModal, isReadingExternalNumberLimits }) => {

    return (
        <div style={{display: 'flex'}}>
            <div style={{flex: 1}}>
                <SearchBar
                    isSearching={false}
                    search={search}
                    searchFcn={onSearchSubmit}
                    cancelFcn={cancelFunction}
                    placeholder='Search by number'
                    addClassNames='ExternalNumbers__search'
                    onChange={onChangeSearch}
                    bottomError
                />
            </div>
            <div>
                <RestrictedView type='disabled' productPermission={PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT + PRODUCT_PERMISSIONS.SETTINGS_EXTERNAL_NUMBERS} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_ADD}>
                    <Button className='ExternalNumbersToolbar__button' disabled={isReadingExternalNumberLimits} onClick={() => onOpenModal(true)}>
                        <Icon name='plus' />
                        External Number
                    </Button>
                </RestrictedView>
            </div>
        </div>

    )
}

export default Toolbar;
